import styled from 'styled-components'
import { Option, RadioButtonGroup } from '../../knowledgeBase/RadioButtonGroup/RadioButtonGroup.style'

const TypeButtonGroup = styled(RadioButtonGroup)`
  margin: 24px 0 0 0;
`

const TypeOption = styled(Option)``

export { TypeButtonGroup, TypeOption }
